// extracted by mini-css-extract-plugin
export default {"root":"Page_root__cFSIj","content":"Page_content__AW2GK","scrollingDisabled":"Page_scrollingDisabled__9bMgr","backgroundImg":"Page_backgroundImg__QAd9G"};